import React from 'react';
import { Badge } from '../ui/badge';

const statusConfig = {
  draft: {
    label: 'Draft',
    className: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700',
  },
  scheduled: {
    label: 'Scheduled',
    className: 'bg-blue-50 text-blue-600 border-blue-200 dark:bg-blue-950 dark:text-blue-400 dark:border-blue-800',
  },
  published: {
    label: 'Published',
    className: 'bg-emerald-50 text-emerald-600 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-400 dark:border-emerald-800',
  },
  failed: {
    label: 'Failed',
    className: 'bg-red-50 text-red-600 border-red-200 dark:bg-red-950 dark:text-red-400 dark:border-red-800',
  },
  active: {
    label: 'Active',
    className: 'bg-emerald-50 text-emerald-600 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-400 dark:border-emerald-800',
  },
  inactive: {
    label: 'Inactive',
    className: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700',
  },
};

export function StatusBadge({ status, className = '' }) {
  const config = statusConfig[status] || { label: status, className: 'bg-gray-100 text-gray-600' };
  return (
    <Badge
      variant="outline"
      className={`text-xs font-medium ${config.className} ${className}`}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </Badge>
  );
}
